import React from 'react';
import {
    CssBaseline,
    ThemeProvider as MUIThemeProvider,
    Paper,
    createTheme,
} from '@mui/material';
import commonThemes from '@/layouts/theme/default';
import globalStyles from '@/layouts/theme/globalStyles';

interface Props {
    children: React.ReactNode;
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
    const theme = createTheme(commonThemes);

    return (
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {globalStyles}
            <Paper>{children}</Paper>
        </MUIThemeProvider>
    );
};

export default ThemeProvider;
